
const digest = 'ab0281f5fa4664196564b563dbe4657381e559463d154c356c9b669f107fe346';
const css = `._labelPillButton_c6chp_1 {
  width: 14px;
  height: 14px;
  border: 1px solid;
  border-radius: 4px;
}

._gray_c6chp_8 {
  background-color: var(--theme-tertiary-background);
  border-color: var(--theme-primary-border);
  color: var(--theme-primary-text);
}

._blue_c6chp_14 {
  background-color: var(--theme-blue-background);
  border-color: var(--theme-blue-border);
  color: var(--theme-blue-text);
}

._green_c6chp_20 {
  background-color: var(--theme-green-background);
  border-color: var(--theme-green-border);
  color: var(--theme-green-text);
}

._yellow_c6chp_26 {
  background-color: var(--theme-yellow-background);
  border-color: var(--theme-yellow-border);
  color: var(--theme-yellow-text);
}

._red_c6chp_32 {
  background-color: var(--theme-red-background);
  border-color: var(--theme-red-border);
  color: var(--theme-red-text);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"labelPillButton":"_labelPillButton_c6chp_1","gray":"_gray_c6chp_8","blue":"_blue_c6chp_14","green":"_green_c6chp_20","yellow":"_yellow_c6chp_26","red":"_red_c6chp_32"};
export { css, digest };
  